import React, { Component } from "react";
import { connect } from "react-redux";

import VideoMuteWork from "./children/VideoMuteWork";

import "@/assets/videoMute.less";

class VideoMute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlaceVisible: false,
    };
  }

  render() {
    return (
      <div className="VideoMute">
        <VideoMuteWork />
      </div>
    );
  }
}

export default connect()(VideoMute);
